import React, { Component } from 'react';
import PromptManager from './promptManager';

/*
    editPrompt = (
        <PromptManager prompt={prompt} data={this.props.data.Prompts} cancel={this.cancel} ws={this.props.ws} />
    )
*/

class PromptPicker extends Component {
    constructor(props) {
        super(props);

        // Establish initial selected option from props.currentPrompt if present
        let initialSelected = 'new';

        const { currentPrompt } = props;
        if (currentPrompt) {
            if (typeof currentPrompt === 'object' && currentPrompt.id) {
                initialSelected = currentPrompt.id;
            } else if (typeof currentPrompt === 'string') {
                initialSelected = currentPrompt;
            }
        }

        this.state = {
            selectedOption: initialSelected,
            editPrompt: false,
            prompt: null
        };
    }

    handleSelectChange = (event) => {
        // This will send an update out to the parent component to track
        const selectedId = event.target.value;
        console.log("Selected ID: ", selectedId);

        // Find the selected prompt using the selected ID
        const selectedPrompt = this.props.prompts.data.find(prompt => prompt.id === selectedId);
        console.log("Selected Prompt: ", selectedPrompt);

        // Keep selectedOption as the ID (string), not the whole object
        this.setState({ selectedOption: selectedId });

        if (this.props.selectionChange) {
            if (selectedPrompt) {
                // If a prompt with the selected ID was found, create a result object to send to the selectionChange prop function
                const result = {
                    id: selectedId,
                    url: selectedPrompt.url
                };
                this.props.selectionChange(result);
            } else {
                // If no prompt was found, send a result object with the selected ID and empty urls object
                const result = {
                    id: selectedId,
                    url: {}
                };
                this.props.selectionChange(result);
            }
        }
    };

    editPrompt = (id) => (e) => {
        // Pull the proper prompt based on id from this.props.prompts.data array
        if (id === 'new') {
            this.setState({ editPrompt: true, prompt: null });
        } else {
            const prompt = this.props.prompts.data.filter(prompt => prompt.id === id)[0];

            console.log("Prompt to send to editor: ", prompt);
            this.setState({ editPrompt: true, prompt: prompt });
        }
    };

    cancel = () => {
        this.setState({ editPrompt: false, prompt: null });
    };

    // Only sync from currentPrompt when we're effectively in "default/new" state
    componentDidUpdate(prevProps) {
        if (prevProps.currentPrompt !== this.props.currentPrompt && this.props.currentPrompt) {
            // If the user has already picked something other than "new",
            // do NOT override their selection with currentPrompt (prevents snapping back to 90001)
            if (this.state.selectedOption && this.state.selectedOption !== 'new') {
                return;
            }

            let newSelected = 'new';
            const { currentPrompt } = this.props;
            if (typeof currentPrompt === 'object' && currentPrompt.id) {
                newSelected = currentPrompt.id;
            } else if (typeof currentPrompt === 'string') {
                newSelected = currentPrompt;
            }

            if (newSelected !== this.state.selectedOption) {
                this.setState({ selectedOption: newSelected });
            }
        }
    }

    render() {
        const { prompts, ws } = this.props;
        const { selectedOption, editPrompt } = this.state;

        // filter prompts to only custom types
        const customPrompts = prompts.data.filter(prompt => prompt.type === 'custom' || prompt.type === 'special');

        let defaultOption;
        if (selectedOption === 'new' || !selectedOption) {
            defaultOption = <option value="new">New Prompt</option>;
        } else {
            const selectedPrompt = prompts.data.find((prompt) => prompt.id === selectedOption);
            if (selectedPrompt) {
                defaultOption = (
                    <option key={selectedPrompt.id} value={selectedPrompt.id}>
                        {selectedPrompt.name}
                    </option>
                );
            } else {
                defaultOption = <option value="notfound">PROMPT NOT FOUND</option>;
            }
        }

        if (!editPrompt) {
            return (
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', padding: '10px', borderRadius: '8px', width: '94%' }}>
                    <select
                        style={{
                            width: selectedOption === 'new' ? '200px' : '270px',
                            padding: '8px',
                            borderRadius: '4px',
                            border: '1px solid #2A6AA9',
                            marginBottom: '10px',
                            backgroundColor: '#ffffff',
                            marginRight: '10px'
                        }}
                        value={selectedOption}            // <-- controlled select
                        onChange={this.handleSelectChange}
                    >
                        {defaultOption}
                        {customPrompts.map((prompt) => (
                            <option key={prompt.id} value={prompt.id}>
                                {prompt.name}
                            </option>
                        ))}
                    </select>
                    <button
                        style={{
                            padding: '10px',
                            width: selectedOption === 'new' ? '150px' : '70px',
                            backgroundColor: '#2A6AA9',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                        onClick={this.editPrompt(selectedOption)}
                    >
                        {selectedOption === 'new' ? 'Create New Prompt' : 'Edit'}
                    </button>
                </div>
            );
        } else {
            return (
                <PromptManager
                    prompt={this.state.prompt}
                    data={prompts}
                    cancel={this.cancel}
                    ws={ws}
                />
            );
        }
    }
}

export default PromptPicker;